export default __webpack_public_path__ + "static/media/wwr-img.ba8344e9.webp";